import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import useAppGlobal from "src/context/useAppGlobal";
import useWareHouseList from "src/hooks/warehouse/useWareHouseList";
import { v4 as uuid } from "uuid";
import WarehouseCreate from "../WarehouseCreate";
import UpdateBtn from "src/components/shared/UpdateBtn";
import DeleteBtn from "src/components/shared/DeleteBtn";
import useWarehouseRemove from "src/hooks/warehouse/useWarehouseRemove";
import { enqueueSnackbar } from "notistack";
import ConfirmComp from "src/components/shared/ConfirmComp";
import ProcessingBadge from "src/components/shared/ProcessingBagde";
import { CHECK_RETURN_PROD_STATUS } from "src/constant";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
import useAuthGlobal from "src/context/useAuthGlobal";
import { Add } from "@mui/icons-material";

export default function useWarehouseBody({ searchBy, keyword, warehouseSelectList, type, warehouseId }) {
  const { userMe } = useAuthGlobal();
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const [pagi, setPagi] = useState({
    limit: 50,
    skip: 0,
  });
  const [whouseId, setWHouseId] = useState();
  const {
    data: warehouse,
    error,
    isLoading,
  } = useWareHouseList({
    ...pagi,
    searchField: !!searchBy ? warehouseSelectList[searchBy - 1]?.value : warehouseSelectList[0]?.value,
    searchValue: !!keyword ? keyword : undefined,
    sortField: "createdAt",
    sortOrder: "asc",
    type: type === CHECK_RETURN_PROD_STATUS.all ? undefined : type,
    warehouse: warehouseId,
  });
  const { trigger: removeWarehouse } = useWarehouseRemove(whouseId);

  const header = [
    {
      id: uuid(),
      title: "STT",
      width: "20px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Kho",
      width: "60px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Chi tiết",
      width: "120px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Tạo kho con",
      width: "20px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      width: "100px",
      align: "center",
    },
  ];

  const handleSubWHCreate = (val) => {
    handleOpenDialog({
      title: "Tạo kho con",
      content: (
        <WarehouseCreate
          parent={val}
          child
        />
      ),
      size: "md",
    });
  };

  const handleSubWHUpdate = (val) => {
    handleOpenDialog({
      title: "Sửa kho con",
      content: (
        <WarehouseCreate
          item={val}
          child
        />
      ),
      size: "md",
    });
  };

  const handleRemoveWarehouse = async (item) => {
    const res = await removeWarehouse();
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const warehouseData = Array.isArray(warehouse?.data) ? warehouse.data : [];

  const bodyList = (
    permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]) ? warehouseData : warehouseData.filter((val) => val?._id === userMe?.currentWarehouse?._id)
  ).map((v, i) => ({
    ...v,
    no: i + pagi?.skip + 1,
    warehouseName: (
      <Box>
        <Typography>{v?.name ?? "-"}</Typography>
      </Box>
    ),
    detail: (
      <Box>
        <ProcessingBadge
          value={v?.managerName + " - " + v?.managerPhone}
          asset={{ color: "processing", text: "processing" }}
        />
        <Typography
          variant="body2"
          mt="6px"
        >
          {v?.fullAddress ?? "-"}
        </Typography>
      </Box>
    ),
    create: (
      <Button
        onClick={() => handleSubWHCreate(v)}
        variant="outlined"
        size="small"
        startIcon={<Add />}
        disabled={!permissionCheck([PERMISSIONS.CREATE_WAREHOUSE_OWN, PERMISSIONS.CREATE_WAREHOUSE_ALL])}
      >
        Tạo kho con
      </Button>
    ),
    includesRow: (Array.isArray(v?.children) ? v.children : []).map((val) => ({
      col: <></>,
      name: val?.name,
      detail: (
        <Box>
          <ProcessingBadge
            value={val?.managerName + " - " + val?.managerPhone}
            asset={{ color: "processing", text: "processing" }}
          />
          <Typography
            variant="body2"
            mt="6px"
          >
            {val?.detailAddress + ", " + val?.ward?.name}
          </Typography>
        </Box>
      ),
      col1: <></>,
      action: (
        <>
          <UpdateBtn
            handleUpdate={() => handleSubWHUpdate(val)}
            disabled={!permissionCheck([PERMISSIONS.UPDATE_WAREHOUSE_ALL, PERMISSIONS.UPDATE_WAREHOUSE_OWN])}
          />
          <DeleteBtn
            disabled={!permissionCheck([PERMISSIONS.DELETE_WAREHOUSE_ALL, PERMISSIONS.DELETE_WAREHOUSE_OWN])}
            handleDelete={() => {
              setWHouseId(val?._id);
              handleOpenDialog({
                content: (
                  <ConfirmComp
                    name={val?.name}
                    onConfirm={() => handleRemoveWarehouse(val?._id)}
                  />
                ),
                size: "md",
              });
            }}
          />
        </>
      ),
    })),
  }));

  const sortData = ["no", "warehouseName", "detail", "create"];

  return {
    header,
    isLoading,
    error,
    setPagi,
    bodyList,
    sortData,
    total: warehouse?.count,
  };
}
